"use strict";

/*!
 * Скрипт виджета корзины в левой колонке
 */

(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};
  var defaultOptions = {
    delay: 60
  };
  var interval;

  // ReSharper disable once InconsistentNaming
  var CartWidget = function CartWidget() {
    var cartUrl = "/Cart";
    var options = {
      itemsCount: null,
      sumRub: null,
      sumUsd: null,
      userId: 0,
      requestUrl: '/Cart/GetDataForWidget'
    };
    var me;
    function saveStorageData() {
      var cart = {
        itemsCount: options.itemsCount,
        sumRub: options.sumRub,
        sumUsd: options.sumUsd
      };
      var b2BCart = $.b2b.storageService.getValue("B2bCart");
      if (b2BCart !== undefined && b2BCart !== null && b2BCart !== '') {
        b2BCart = JSON.parse(b2BCart);
      } else {
        b2BCart = {};
      }
      b2BCart[options.userId] = cart;
      $.b2b.storageService.setValue("B2bCart", JSON.stringify(b2BCart));
    }
    function refreshWidgetData() {
      if (!me) return;
      var cartItemsCount = me.find('#cartItemsCount');
      //В новом UI у корзины нет общего-кол-ва товаров.
      if (cartItemsCount) cartItemsCount.html(options.itemsCount);
      me.find('#cartWidgetSumUsd').html(options.sumUsd);
      me.find('#cartWidgetSumRub').html(options.sumRub);
    }
    this.option = function (name, value) {
      if (name) {
        if (!value) {
          return options[name];
        }
        options[name] = value;
      }
    };
    this.refresh = function () {
      $.b2b.ajax({
        url: options.requestUrl,
        success: function success(data) {
          if (data !== undefined && data !== null) {
            options.itemsCount = data.itemsCount;
            options.sumUsd = data.priceUsd;
            options.sumRub = data.priceRub;
            refreshWidgetData();
            saveStorageData();
          }
        },
        error: function error(jqXHR) {
          clearInterval(interval);
          $.b2b.errors.showAjaxError(jqXHR);
        }
      });
    };
    this.init = function (opt) {
      options = $.extend({}, defaultOptions, opt);
      me = options.widget;
      if ($.b2b.storageService.isAvailable() && options.userId > 0) {
        saveStorageData();
        $.b2b.storageService.addHandler(function (e) {
          if (e.key === "B2bCart") {
            var cart = e.newValue;
            if (cart !== undefined && cart !== null && cart !== '') {
              cart = JSON.parse(cart)[options.userId];
              if (cart !== undefined && cart !== null) {
                options.itemsCount = cart.itemsCount;
                options.sumRub = cart.sumRub;
                options.sumUsd = cart.sumUsd;
                refreshWidgetData();
              }
            }
          }
        });
      }
    };
    this.bindAdd2CartEvent = function (elem, onItemAdded) {
      if ($.fn.popover) {
        var p = elem.popover({
          html: true,
          trigger: 'click',
          placement: 'right',
          content: function content() {
            var code = $(this).attr("id");
            var hasCode = true;
            if (code === undefined) {
              code = $(this).data("articul");
              hasCode = false;
            }
            code = encodeURI(code);
            var multiplicity = $(this).data('multiplicity');
            if (!multiplicity) {
              multiplicity = 1;
            }
            var content = $('#positionBasketWrapper').clone().removeClass("hidden").removeAttr("id");
            content.html(content.html().replace(/{code}/g, code));
            content.html(content.html().replace(/{hasCode}/g, hasCode));
            content.html(content.html().replace(/{multiplicity}/g, multiplicity));
            return content.html();
          }
        });
        elem.prop('haspopover', 'true');
        p.on('hide.bs.popover', function () {
          $(this).find('a').removeClass('active');
        });
        p.on('shown.bs.popover', function () {
          $(this).find('a').addClass('active');
          var btnMinus = $('button[id^=Minus_]');
          var btnPlus = $('button[id^=Plus_]');
          var step = parseInt(btnMinus.data('step'), 10);
          if (!step) {
            step = 1;
          }
          if (step > 1) {
            btnMinus.attr('title', 'Товар доступен к отгрузке в количестве, кратном ' + step);
            btnPlus.attr('title', 'Товар доступен к отгрузке в количестве, кратном ' + step);
            $('div[id^=MultiplicityTitle_]').show();
          } else {
            btnMinus.removeAttr('title');
            btnPlus.removeAttr('title');
            $('div[id^=MultiplicityTitle_]').hide();
          }
          btnMinus.click(function (event) {
            event.preventDefault();
            var code = $(this).attr('id').substring("Minus_".length);
            var summary = 'input[id=\'qty_' + code + '\']';
            var value = parseInt($(summary).val(), 10);
            var step = parseInt($(this).data('step'), 10);
            if (!step) {
              step = 1;
            }
            if (value > 0) {
              if (value % step > 0) {
                value = step * Math.floor(value / step);
              } else {
                value -= step;
              }
              $(summary).val(value);
            }
          });
          btnPlus.click(function (event) {
            event.preventDefault();
            var code = $(this).attr('id').substring("Plus_".length);
            var summary = 'input[id=\'qty_' + code + '\']';
            var value = parseInt($(summary).val(), 10);
            var step = parseInt($(this).data('step'), 10);
            if (!step) {
              step = 1;
            }
            if (value % step > 0) {
              value = step * Math.ceil(value / step);
            } else {
              value += step;
            }
            $(summary).val(value);
          });
          $('input[id^=qty_]').on('blur', function (event) {
            var target = $(event.target);
            var value = target.val();
            var step = parseInt(target.data('step'), 10);
            if (!step) {
              step = 1;
            }
            if (value % step > 0) {
              value = step * Math.ceil(value / step);
              target.val(value);
            }
          });
          $('input[id^=qty_]').keydown(function (event) {
            ///<summary>Ограничение на ввод символов в кол-во</summary>
            var key = event.charCode || event.keyCode || 0;
            return key === 8 || key === 9 || key === 46 || key === 110 || key === 190 || key >= 35 && key <= 40 || key >= 48 && key <= 57 || key >= 96 && key <= 105;
          });
          $('input[id^=btnBasketAdd_]').click(function (event) {
            event.preventDefault();
            var btn = $(this);
            var catalogTblItem = $(event.target).parents('.cl0.form').find('.catalogBasket');
            if (catalogTblItem.length === 0) catalogTblItem = $(event.target).parents('td').find('.catalogBasket');
            if (catalogTblItem.length === 0) catalogTblItem = $(event.target).parents('tr').find('.catalogBasket');
            var recommendedUrlParam = "";
            var currentUrl = new URL(window.location.href);
            if (currentUrl.searchParams.has('recommended')) {
              recommendedUrlParam = "?recommended&code=" + currentUrl.searchParams.get('code');
            }
            var code = btn.attr('id').substring("btnBasketAdd_".length);
            var summary = 'input[id=\'qty_' + code + '\']';
            var count = $(summary).val();
            if (count > 0) {
              var tt = btn.parent().parent();
              tt.find('.addBasket_loading').removeClass('hidden');
              btn.attr('disabled', 'disabled');
              tt.find('button[id^=Minus_], button[id^=Plus_], input[id^=qty_]').attr('disabled', 'disabled');
              var data = {
                quantity: count
              };
              var url = "/Cart/AddCartItemByCode".concat(recommendedUrlParam);
              if ($('#productHasCode').val() === "true") {
                data.code = code;
              } else {
                data.article = decodeURI(code);
                url = "/Cart/AddCartItemByArticle".concat(recommendedUrlParam);
              }
              $.ajax({
                url: url,
                type: "POST",
                data: data,
                cache: false,
                success: function success(data) {
                  // set data for google tag manager
                  // catalogTblItem.data('articul')
                  // catalogTblItem.data('categoryId')
                  var partNumber = catalogTblItem.data('articul');
                  dataLayer.push({
                    'event': 'addToCart',
                    'modelid': partNumber
                  });
                  // refresh widget and show toast
                  if (data.Success) {
                    catalogTblItem.data('isinbasket', 1);
                    // noQtyBasket - если не нужно отображать текущее количество добавляемого товара в корзине
                    if (catalogTblItem.find('a').length > 0 && !catalogTblItem.find('a').hasClass('noQtyBasket')) {
                      catalogTblItem.html('<a href="' + cartUrl + '" target="basket_' + options.userId + '" class="noBasket"><div>' + count + '</div></a>');
                    } else {
                      var qtyDiv = catalogTblItem.find('div:last');
                      qtyDiv.html(parseInt(qtyDiv.html(), 10) + parseInt(count, 10));
                    }
                    catalogTblItem.popover('hide');
                    var notice = $("<span>\u0422\u043E\u0432\u0430\u0440 <b>{articul}</b> \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0443</span>");
                    notice.html(notice.html().replace('{articul}', catalogTblItem.data('articul')));
                    $.b2b.toastNotificationService.show(notice.html(), {
                      type: "success",
                      click: function click() {
                        var form = $('<form method="get" class="hidden" action="' + cartUrl + '" target="basket_' + options.userId + '"></form>');
                        $('body').append(form);
                        form.submit();
                        form.remove();
                      }
                    });
                    var mainMenuCartWidget = $.b2b.MainMenuWidgets.getWidget('#cart-widget');
                    if (mainMenuCartWidget) {
                      mainMenuCartWidget.update();
                    }
                    if (onItemAdded) onItemAdded(data);
                    if (options.requestUrl != null) $.b2b.cartWidget.refresh();
                  }
                },
                error: function error(jqXhr) {
                  tt.find('.addBasket_loading').addClass('hidden');
                  btn.removeAttr('disabled');
                  tt.find('button[id^=Minus_], button[id^=Plus_], input[id^=qty_]').removeAttr('disabled');
                  catalogTblItem.popover('hide');
                  $.b2b.errors.showAjaxError(jqXhr);
                }
              });
            }
          });
          $('input[id^=btnCreateExpressBill_]').on({
            click: function click() {
              var catalogTblItem = $(event.target).parents('.cl0.form').find('.catalogBasket');
              if (catalogTblItem.length === 0) catalogTblItem = $(event.target).parents('td').find('.catalogBasket');
              catalogTblItem.popover('hide');
            }
          });
          var expressBillAboutPopover = $("#expressBillPopover").dxPopover({
            target: "#expressBill-about",
            position: "right",
            width: "auto",
            animation: {
              show: {
                type: "pop",
                from: {
                  scale: 0
                },
                to: {
                  scale: 1
                }
              },
              hide: {
                type: "fade",
                from: 1,
                to: 0
              }
            }
          }).dxPopover("instance");
          $("#expressBill-about").off().on({
            mouseover: function mouseover(e) {
              var target = $(e.currentTarget);
              // Не перерисовывать поповер, если курсор находится на той же строке
              if (target[0] === expressBillAboutPopover.option("target")[0] && expressBillAboutPopover.option("visible")) return;
              expressBillAboutPopover.option("contentTemplate", function () {
                return "<div id=\"expressBill-about-text\">\"<b>Экспресс-счет</b>\" для быстрого создания счёта на 1 и более единиц одной позиции при условии согласия на указанную в прайс-листе цену.</div>";
              });
              expressBillAboutPopover.option("target", target);
              expressBillAboutPopover.show();
            },
            mouseleave: function mouseleave(e) {
              expressBillAboutPopover.hide();
            }
          });
        });
        $('.catalogBasket').on('click', function () {
          var isInBasket = $(this).data('isinbasket');
          if (isInBasket === undefined) return;
          if (isInBasket === 0) {
            $('.catalogBasket').not(this).popover('hide');
          } else {
            $('.catalogBasket').popover('hide');
          }
        });
        $(document).on('click', function (e) {
          var element = $(e.target);
          if (element.parents('.popover').length === 0 && !element.hasClass('.catalogBasket') && element.parents('.catalogBasket').length === 0) {
            $('.catalogBasket').popover('hide');
          }
        });
      }
    };
    this.bindAdd2CartEvents = function (onItemAdded) {
      this.bindAdd2CartEvent($('.catalogBasket'), onItemAdded);
    };
  };
  $.b2b.cartWidget = new CartWidget();
})(jQuery);